<template>
  <div class="create-group">
    <div class="top">
      <div class="plan" @click="cancel">广告计划</div>
      <div>></div>
      <div class="new">新建广告单元</div>
    </div>
    <div class="create-plan">
      <el-form label-width="120px" ref="form" label-position="left" :model="form" :rules="rules">
        <div class="form-title">基本属性</div>
        <el-form-item label="所属计划" prop="plan_id">
          <el-select v-model="form.plan_id" placeholder="请选择" style="width: 350px;">
            <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单元名称" prop="group_name">
          <el-input v-model="form.group_name" style="width: 350px;" placeholder="请输入广告计划名称"></el-input>
        </el-form-item>
        <el-form-item label="投放目标">
          <el-radio-group v-model="form.type">
            <el-radio-button label="1">点击</el-radio-button>
            <el-radio-button label="2">展现</el-radio-button>
            <el-radio-button label="3">转化</el-radio-button>
          </el-radio-group>
          <div class="font" v-html="font[form.type]"></div>
        </el-form-item>
        <div class="form-title">流量类型</div>
        <el-form-item label="广告类型" prop="group_type">
          <el-select v-model="form.group_type" placeholder="请选择" style="width: 350px;">
            <el-option label="信息流列表页" value="1"></el-option>
            <el-option label="信息流详情页" value="2"></el-option>
            <el-option label="互动广告" value="3"></el-option>
            <el-option label="开屏广告" value="4"></el-option>
            <el-option label="横幅广告" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放媒体" prop="group_type">
          <el-select v-model="form.media_type" placeholder="请选择" style="width: 350px;">
            <el-option label="2345天气王" value="1"></el-option>
            <el-option label="2345手机游览器" value="2"></el-option>
            <el-option label="2345影视大全" value="3"></el-option>
            <el-option label="2345看图王" value="4"></el-option>
            <el-option label="2345好压" value="5"></el-option>
            <el-option label="2345王牌输入法" value="6"></el-option>
            <el-option label="2345安全卫士" value="7"></el-option>
            <el-option label="2345网址导航APP" value="8"></el-option>
          </el-select>
        </el-form-item>

        <div class="form-title">定向设置</div>
        <el-form-item label="地域">
          <el-radio-group v-model="other.city">
            <el-radio-button label="1">不限</el-radio-button>
            <el-radio-button label="2">自定义</el-radio-button>
          </el-radio-group>
          <el-cascader v-if="other.city === '2'" :options="options" :props="props" v-model="other.city_i" clearable collapse-tags style="width: 350px; margin-left: 20px;"></el-cascader>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="other.sex">
            <el-radio-button label="1">不限</el-radio-button>
            <el-radio-button label="2">男</el-radio-button>
            <el-radio-button label="3">女</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <el-checkbox-group v-model="other.age">
            <el-checkbox-button label="1">18岁以下</el-checkbox-button>
            <el-checkbox-button label="2">18-22岁</el-checkbox-button>
            <el-checkbox-button label="3">23-40岁</el-checkbox-button>
            <el-checkbox-button label="4">40岁以上</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="兴趣人群包">
          <el-radio-group v-model="other.page">
            <el-radio-button label="1">不限</el-radio-button>
            <el-radio-button label="2">定向</el-radio-button>
          </el-radio-group>
          <el-cascader v-if="other.page === '2'" :options="peopleOpt" :props="props" v-model="other.people" clearable collapse-tags style="width: 350px; margin-left: 20px;"></el-cascader>
        </el-form-item>
        <el-form-item label="新老用户">
          <el-radio-group v-model="other.user">
            <el-radio-button label="1">不限</el-radio-button>
            <el-radio-button label="2">新用户</el-radio-button>
            <el-radio-button label="3">老用户</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="操作系统">
          <el-radio-group v-model="other.system">
            <el-radio-button label="1">不限</el-radio-button>
            <el-radio-button label="2">Android</el-radio-button>
            <el-radio-button label="3">IOS</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机价格">
          <el-checkbox-group v-model="other.price">
            <el-checkbox-button label="1">高端</el-checkbox-button>
            <el-checkbox-button label="2">中高端</el-checkbox-button>
            <el-checkbox-button label="3">中低端</el-checkbox-button>
            <el-checkbox-button label="4">低端</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="网络情况">
          <el-checkbox-group v-model="other.net">
            <el-checkbox-button label="1">WIFI</el-checkbox-button>
            <el-checkbox-button label="2">4G</el-checkbox-button>
            <el-checkbox-button label="3">3G</el-checkbox-button>
            <el-checkbox-button label="4">2G</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>

        <div class="form-title">广告频次</div>
        <el-form-item label="展现频次(次)" prop="show_num">
          <el-input v-model="form.show_num" style="width: 350px;" placeholder="展现频次(0-10,0不限频次)"></el-input>
        </el-form-item>
        <el-form-item label="点击频次(次)" prop="click_num">
          <el-input v-model="form.click_num" style="width: 350px;" placeholder="点击频次(0-10,0不限频次)"></el-input>
        </el-form-item>

        <div class="form-title">出价</div>
        <!-- <el-form-item label="付费方式">
          <el-button type="primary" plain disabled>oCPC</el-button>
        </el-form-item> -->
        <el-form-item label="点击出价（元）" prop="price">
          <el-input v-model="form.price" style="width: 350px;" placeholder="请输入点击出价"></el-input>
        </el-form-item>
        <div style="height: 80px;"></div>

      </el-form>
      <div style="position: fixed; z-index: 10; background: #fff; width: 1200px; left: calc(50% - 600px); height: 80px; bottom: 0; display: flex; align-items: center; justify-content: center;">
        <el-button type="primary" @click="submitForm('form', 'groupCancel')">保存并关闭</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </div>
  </div>

</template>

<script>
import options from '../../../plugin/city_code.js';
import peopleOpt from '../../../plugin/people_type.js';
export default {
  name: 'createGroup',
  props: ['group_data'],
  data() {
    return {
      form: {
        group_id: '',
        plan_id: '',
        type: '1',
        group_type: '',
        media_type: '',
        group_name: '',
        price: '',
        show_num: '',
        click_num: ''
      },
      other: {
        city: '1',
        sex: '1',
        age: ['1'],
        page: '1',
        user: '1',
        system: '1',
        price: ['1'],
        net: ['1'],
        city_i: [],
        people: []
      },
      props: { multiple: true, children: 'city', value: 'code', label: 'name' },
      options: options,
      peopleOpt: peopleOpt,
      type: 'add',
      rules: {
        plan_id: [
          { required: true, message: '请选择计划', trigger: 'change' }
        ],
        group_type: [
          { required: true, message: '请选择广告类型', trigger: 'change' }
        ],
        media_type: [
          { required: true, message: '请选择投放媒体', trigger: 'change' }
        ],
        group_name: [
          { required: true, message: '请输入单元名称', trigger: 'blur' },
          { min: 0, max: 30, message: '长度不能超过30个字符', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入点击出价', trigger: 'blur' }
        ],
        click_num: [
          { required: true, message: '请输入点击频次', trigger: 'blur' }
        ],
        show_num: [
          { required: true, message: '请输入展现频次', trigger: 'blur' }
        ],
        purpose: [
          { required: true, message: '请选择目的', trigger: 'change' }
        ]
      },
      font: ['', '*将广告投放给点击意愿高的用户，按CPC计费', '*以广告的曝光为投放目标，按CPM计费', '<p style="line-height: 25px; margin-top: 8px;">将广告投放给转化意愿高的用户，按oCPC计费。</p><p style="line-height: 25px;">若投放趣头条，要求单元绑定创意必须对接API回传转化或使用自助建站/赤兔</p>'],
      planLists: []
    };
  },
  created() {
    // 编辑
    if (this.group_data.group_id !== undefined && parseInt(this.group_data.group_id) > 0) {
      this.form = {
        group_id: this.group_data.group_id,
        plan_id: this.group_data.plan_id,
        type: this.group_data.type,
        group_type: this.group_data.group_type + '',
        media_type: this.group_data.media_type + '',
        group_name: this.group_data.group_name,
        price: this.group_data.price,
        show_num: this.group_data.show_num,
        click_num: this.group_data.click_num
      };
      this.other = this.group_data.other_info;
      this.type = 'edit';
    }
    this.$http.post('/trader/index/group_form', {
      group_id: this.form.group_id
    }).then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
        this.$function.hiddenLoading();
        // this.getData();
      }
    });
  },
  methods: {
    getData() {
      this.$http.post('/trader/index/getGroupPlanLists', {
        keyword: this.keyword,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = Math.ceil(res.count / this.pageSize);
          this.$function.hiddenLoading();
        }
      });
    },
    submitForm(formName, make) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.type === 'add' ? '/trader/index/createGroupPlan' : '/trader/index/saveGroupPlan';
          this.$http.post(url, { form: this.form, other: this.other }).then(res => {
            if (res.code === 200) {
              this.$message.success('操作成功');
              this.$emit('plan_call_back', make);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$emit('plan_call_back', 'groupCancel');
    }
  }
};
</script>

<style lang="less">
  .create-group {
    .form-title {
      color: #1890ff;
      line-height: 20px;
      font-size: 16px;
      border-left: 2px solid #1890ff;
      padding-left: 8px;
      margin-bottom: 40px;
    }
    .font {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      p {
        height: 20px;
        line-height: 25px;
      }
    }
    .create-plan {
      background: #fff;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      overflow-y: auto;
      border-radius: 4px;
      padding: 30px 20px 0 20px;
    }
    .top {
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      height: 64px;
      font-size: 14px;
      color: #606266;
      background: #fff;
      padding: 0 25px;
      div {
        margin-right: 5px;
      }
      .plan:hover {
        cursor: pointer;
        color: #1890FF;
      }
    }
    .el-radio-button__inner {
      background: #f3f9fe;
      -webkit-box-shadow: none;
      box-shadow: none;
      border: 1px solid #1890ff;
      color: #1890ff;
      line-height: 1;
      white-space: nowrap;
      vertical-align: middle;
      background: #fff;
      border: 1px solid #dcdfe6;
      font-weight: 500;
      border-left: 0;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      margin: 0;
      cursor: pointer;
      -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
      transition: all .3s cubic-bezier(.645,.045,.355,1);
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 0;
    }

    .is-active .el-radio-button__inner {
        background: #f3f9fe;
        -webkit-box-shadow: none;
        box-shadow: none;
        border: 1px solid #1890ff;
        color: #1890ff;
    }
  }

</style>
